import React from 'react';

const Spotlight = props => {
  return (
    <svg viewBox="0 0 19 22" {...props}>
      <path
        d="M6.31163081,17.344657 C5.69691209,16.7299383 6.87713393,14.5533387 8.94736433,
        12.4827908 C11.0179122,10.4125604 13.1945118,9.23265605 13.8092306,9.84737477 C14.4236318,
        10.461776 13.2437274,12.6386931 11.173497,14.708606 C9.10294913,16.7791539 6.92634953,
        17.9593757 6.31163081,17.344657 M3.98801945,3.79734869 C3.35361449,4.08756197 2.66840633,
        4.55304629 2.01812537,5.16046205 L2.01812537,2.16720101 C2.01812537,1.67250485 2.42074073,
        1.27020701 2.91511937,1.27020701 L7.28228945,1.27020701 C7.77698561,1.27020701 8.17928345,
        1.67250485 8.17928345,2.16720101 L8.17928345,4.94677109 L6.17827241,3.87768125 C5.49909713,
        3.51507341 4.68783353,3.47728853 3.98801945,3.79734869 M15.3288813,11.098086 C15.7756319,
        9.97914557 15.2726802,8.70525533 14.2042254,8.14896029 C13.9689431,8.02639757 13.7263578,
        7.90192973 13.490123,7.78412981 L9.44936345,5.62531133 L9.44936345,2.16720101 C9.44936345,
        0.972373248 8.47711721,0.000127008 7.28228945,0.000127008 L2.91511937,
        0.000127008 C1.72029161,0.000127008 0.748045368,0.972373248 0.748045368,
        2.16720101 L0.748045368,6.63248477 C0.535624488,6.94492445 0.356225688,
        7.25514149 0.217786968,7.55456285 C-0.104813352,8.25120173 -0.061948152,
        9.06214781 0.299707128,9.73973549 L4.60242065,17.7425096 C5.16252593,18.7839752 6.40879193,
        19.2716859 7.51280897,18.8477967 C8.98387913,18.2829286 10.6480014,17.1766889 12.1759077,
        15.6487827 C13.665394,14.1592964 14.7529,12.5408969 15.3288813,11.098086"
        fill="#7500CF"
      ></path>
      <path
        d="M16.4108624,16.7046637 L15.2560422,15.8765715 C14.9718618,15.6720887 14.5746443,
        15.7371803 14.3701614,16.0226307 C14.1656785,16.3071287 14.2307701,16.7040287 14.5162206,
        16.9085115 L15.6707233,17.7366037 C15.7415303,17.7870894 15.8186876,17.8216991 15.8987027,
        17.8397977 C16.1406529,17.8953637 16.403242,17.805188 16.5569216,17.5905445 C16.7614045,
        17.3060466 16.6959954,16.9091466 16.4108624,16.7046637"
        fill="#7500CF"
      ></path>
      <path
        d="M18.050885,13.5675978 L16.6718956,13.2253113 C16.3321492,13.1405334 15.987005,
        13.3481915 15.9025447,13.688573 C15.8180844,14.0289544 16.0254249,14.3734636 16.3658064,
        14.4579239 L17.7451132,14.8002105 C17.829256,14.8211668 17.9140339,14.824342 17.994684,
        14.8119587 C18.2404444,14.7738563 18.4506427,14.5928699 18.5144642,14.3369488 C18.5989245,
        13.9965674 18.391584,13.6520582 18.050885,13.5675978"
        fill="#7500CF"
      ></path>
      <path
        d="M13.3060566,18.2063745 C13.0945883,17.9250518 12.6970533,17.8691683 12.4170006,
        18.0800016 C12.1363129,18.2908349 12.0801119,18.6890049 12.2906277,18.9690576 L13.1342783,
        20.0918083 C13.2282642,20.2169112 13.3590825,20.2969262 13.4997438,20.3296308 C13.6759674,
        20.3696383 13.868067,20.3353461 14.0236518,20.2181813 C14.3043395,20.007348 14.3605405,
        19.6091779 14.1497073,19.3291253 L13.3060566,18.2063745 Z"
        fill="#7500CF"
      ></path>
      <g transform="translate(9.525600, 19.097272)">
        <path
          d="M1.30526122,0.69235236 C1.2001621,0.35673372 0.844222176,0.17098452 0.509873616,
          0.27576612 C0.174572496,0.38054772 -0.011494224,0.73680516 0.092969856,
          1.07115372 L0.512096256,2.41172316 C0.558771696,2.56095756 0.655297776,
          2.68034508 0.777225456,2.75813748 C0.929635056,2.8552986 1.12205218,2.88673308 1.30780138,
          2.82862692 C1.64278498,2.7235278 1.82916922,2.36727036 1.72438762,2.03323932 L1.30526122,
          0.69235236 Z"
          fill="#7500CF"
        ></path>
      </g>
    </svg>
  );
};
export default Spotlight;
